import userGroupsIdMethods from './UserGroups.id'
import userGroupsPaginated from './UserGroups.paginated'

export const LicenseUserGroupServices = {
  id: userGroupsIdMethods,
  ...userGroupsPaginated
}

export * from './UserGroups.types'
